import { Stack } from "@mui/material";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import show from "../../../api/auth/storePages/show";
import StorePage from "../../../components/displays/storePages/StorePage";
import useCheckoutStore from "../../../stores/public/useCheckoutStore";

export default function PreviewStorePage(){
  const { storePage, setStorePage } = useCheckoutStore();
  const { id } = useParams();

  useEffect(() => {
    show(id, (response) => {
      setStorePage(response);
    });
  }, []);

  if(!storePage) return null;

  return (
    <Stack
      border="1px solid black"
      borderRadius="10px"
      sx={{
        bgcolor: storePage.background_color
      }}
    >
      <Stack>
        <StorePage storePage={storePage} />
      </Stack>
    </Stack>
  );
}